import React, { Component } from "react";
import { DatePicker as _DatePicker } from "antd";
import Button from "../Button";
import dayjs from "dayjs";

const { RangePicker } = _DatePicker;

class DatePickerComp extends Component {
  change = (value) => {
    const { onChange } = this.props;
    if (Array.isArray(value)) {
      const [from, to] = value;
      onChange({ from, to });
    }
  };

  last7Days = () => {
    const { onChange, endDate } = this.props;
    const from = endDate
      .clone()
      .subtract(6, "day")
      .startOf("day");
    const to = endDate.clone().startOf("day");
    onChange({ from, to });
  };

  allTime = () => {
    const { onChange, endDate } = this.props;
    const from = dayjs("2024-12-01", "YYYY-MM-DD").startOf("day");
    const to = endDate.clone().startOf("day");
    onChange({ from, to });
  };

  disabledDates = (current) => {
    const { endDate } = this.props;
    return (
      current &&
      (current < dayjs("2024-12-01", "YYYY-MM-DD").startOf("day") ||
        current > endDate.clone().endOf("day"))
    );
  };

  render() {
    const { from, to } = this.props;
    return (
      <div className="bl-date-picker">


        <div className="bl-date-picker-inner">
          <div className="bl-select-date-text">Select date range</div>
          <RangePicker
            className="bl-custom-picker"
            disabledDate={this.disabledDates}
            value={[dayjs(from), dayjs(to)]}
            format="DD/MM/YYYY"
            onChange={this.change}
          />
        </div>

        <Button type="blue" text="Last 7 days" onClick={this.last7Days} />

        <Button type="blue" text="All time" onClick={this.allTime} />
      </div>
    );
  }
}

export default DatePickerComp;
